import { dataLayerService } from './dataLayerService';

export const adobeAnalyticsPlugin = () => ({
  name: 'adobe-analytics',

  initialize: () => {
    const adobeLaunch = document.createElement('script');
    adobeLaunch.setAttribute('src', import.meta.env['VITE_ADOBE_ANALYTICS_URL']!);
    document.head.prepend(adobeLaunch);
  },
  track: ({ payload }) => {
    if (payload.properties?.suppressBridgeTracking) return;

    const dataLayer = dataLayerService.getDataLayer();
    document.body.dispatchEvent(
      new CustomEvent(payload.event, {
        bubbles: true,
        composed: true,
        detail: { ...dataLayer, ...payload.properties },
      }),
    );
  },
  identify: ({ payload }) => {
    if (payload.traits) {
      dataLayerService.updateDataLayer(payload.traits);
      const dataLayer = dataLayerService.getDataLayer();
      document.body.dispatchEvent(
        new CustomEvent('identify_user', {
          bubbles: true,
          composed: true,
          detail: dataLayer,
        }),
      );
    }
  },
});

export default adobeAnalyticsPlugin;
